import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ConfirmDeleteModalComponent } from 'src/app/modules/core/components/delete-modal/confirm-delete-modal-component';
import { ArrayHelper } from 'src/app/models/helpers/array-helper';
export class VideosComponent {
    constructor(videoService) {
        this.videoService = videoService;
        this.videos = [];
        this.confirmDeleteMsg = "Are you sure you want to delete";
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            for (let video of this.videos) {
                video.date = new Date(video.date);
            }
            this.sortCollectionByDate();
        });
    }
    addVideo(video) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield this.videoService.addVideo(this.plantingSiteAreaId, video);
            video.id = result;
            this.videos.push(video);
            this.sortCollectionByDate();
        });
    }
    updateVideo(video) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.videoService.updateVideo(video);
            let index = this.videos.findIndex(x => x.id == video.id);
            this.videos[index] = video;
            this.sortCollectionByDate();
        });
    }
    delete(video) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.confirmDeleteModal.showAwait(this.confirmDeleteMsg);
            if (result) {
                yield this.videoService.deleteVideo(video.id);
                let index = this.videos.findIndex(x => x.id == video.id);
                this.videos.splice(index, 1);
                index = this.sortedvideos.findIndex(x => x.id == video.id);
                this.sortedvideos.splice(index, 1);
            }
        });
    }
    sortCollectionByDate() {
        this.sortedvideos = ArrayHelper.sortBy(this.videos, false, video => video.date);
    }
}
